module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAABMBAMAAABjb6FuAAAAIVBMVEUAAAAApeEApOEAoOAAo+AApOAAouAAouIAoNwAo+IAo+H7Zl3XAAAAC3RSTlMAMywGJxkPHhQiCvBroFoAAACWSURBVDjLXccxFYMwFADATwIBOrUOGgmRgAQk4KBIiAQcFKdd++62i+317xmdN77ywqPynTc+8oWHP/nNE5945nHxgyc+8wePjXc+8JUXHpXvvPGRLzz8yW+e+MQzj4sfPPGJZx4b73zgMy88Kt954yMvPCo/+c1HvvDM4+IHT3zimcfGOx/4zB88Kt954ysvPN78w78/Zn4yK9aLi3YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/WZBankPC/sanjiao1.png
// module id = R/TX
// module chunks = 70